import React from "react";
import {useForm} from "react-hook-form";
import styled from "styled-components";

import Logo from "../Components/Logo";
import AuthContainer from "../Components/Auth/Container";
import Input from "../Components/Form/Input";
import Button from "../Components/Form/Button";
import ButtonLink from "../Components/Form/ButtonLink";
import OrWrapper from "../Components/Form/OrWrapper";
import Auth from "../Layouts/Auth";
import ElementWrapper from "../Components/Form/ElementWrapper";
import {Helmet} from "react-helmet-async";
import Form from "../Components/Auth/Form";
import {useHistory} from 'react-router-dom';
import {log_in} from '../../util/auth'
import api from '../../util/api';
import MainWrapper from "../Components/Main/MainWrapper";



const ErrorAlert = styled.div`
    width: 100%;
    background: red;
    margin: 0 auto 20px;
    padding: 15px;
    border-radius: 5px;
    border: solid 1px red;
    
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
`;

const RegistrationPanelHeader = styled.h2`
    color: #5562C0;
    text-align: center;
    font-size: 28.5px;
    line-height: 34px;
    font-weight: 700;
`;

const FormWrapper = styled.div`
    display: ${(props) => (props.hidden ? "none" : "block")};
`;

const FormNotice = styled.div`
    text-align: center;
    font-size: 18px;
    line-height: 29px;
    margin-bottom: 20px;
`;

const Login = (test_props) => {
    const {register, handleSubmit, errors} = useForm();
    const history = useHistory();
    const windowUrl = window.location.search;
    const params = new URLSearchParams(windowUrl);
    const [instructorName, setInstructorName] = React.useState(null);
    const [studentExists, setStudentExists] = React.useState(false);
    const [studentEmail, setStudentEmail] = React.useState('');
    const [submissionError, setSubmissionError] = React.useState(null);
    const onSubmit = (data) => {
        api(true).get('/sanctum/csrf-cookie')
            .then(() => api(true).post('/fortify/register', {
                email: studentEmail,
                password: data.password,
                password_confirmation: data.password_confirmation,
                first_name: data.first_name,
                last_name: data.last_name,
                student_name: data.student_name
            }))
            .then(() => api(true).post('/fortify/login', { 
                email: data.email,
                password: data.password
            }))
            .then(() => api().post(`/student-invite/${params.get('uuid')}/accept`))
            .then(() => log_in())
            .catch((e) => {
                setSubmissionError(e.errors.toString());
            });
    };

    React.useEffect(() => {
        if (!params.get('uuid')) {

            window.location.href = '/';
            // history.push('/');
        } else {
            api(true).get('/student-invite/' + params.get('uuid'))
                .then(function (response) {
                    if (response) {
                        setStudentExists(response.data.student_invite.student_exists);
                        setStudentEmail(response.data.student_invite.email);
                        setInstructorName(response.data.student_invite.instructor.instructor_name);
                    } else {
                        window.location.href = '/';
                    }
                })
                .catch((e) => {
                    window.location.href = '/';
                });
        }
    }, []);


    return (
        <MainWrapper>
            <Auth>
                <Helmet>
                    <title>Login - MUZE</title>
                </Helmet>
                <Logo />
                <AuthContainer>
                    <RegistrationPanelHeader>Create a Student Account for {instructorName}'s
                        Course</RegistrationPanelHeader>
                    <FormWrapper hidden={!studentExists}>
                        <FormNotice>A user with the email address <strong>{studentEmail}</strong> already exists. Please
                            login to your account to accept the invite.</FormNotice>
                        <ButtonLink href="/login">Login</ButtonLink>
                    </FormWrapper>
                    <FormWrapper hidden={studentExists}>
                        <Form onSubmit={handleSubmit(onSubmit)}>
                            <ErrorAlert hidden={submissionError == null}>{submissionError}</ErrorAlert>
                            <ElementWrapper>
                                <Input
                                    id="first_name"
                                    label="First Name"
                                    type="text"
                                    ref={register({
                                    required: {
                                        value: true,
                                        message: "First Name is Required",
                                    },
                                })}
                                    errors={errors.first_name}
                                    autocomplete='given-name'
                                />
                            </ElementWrapper>
                            <ElementWrapper>
                                <Input
                                    id="last_name"
                                    label="Last Name"
                                    type="text"
                                    ref={register({
                                    required: {
                                        value: true,
                                        message: "Last Name is Required",
                                    },
                                })}
                                    errors={errors.last_name}
                                    autocomplete='family-name'
                                />
                            </ElementWrapper>
                            <ElementWrapper>
                                <Input
                                    id="student_name"
                                    label="Student Name"
                                    type="text"
                                    ref={register({
                                    required: {
                                        value: false,
                                    },
                                })}
                                    errors={errors.student_name}
                                    autocomplete='student-name'
                                />
                            </ElementWrapper>
                            <ElementWrapper>
                                <Input
                                    id="email"
                                    label="Email"
                                    type="email"
                                    value={studentEmail}
                                    disabled
                                    readonly
                                />
                            </ElementWrapper>
                            <ElementWrapper>
                                <Input
                                    id="password"
                                    label="Password"
                                    type="password"
                                    ref={register({
                                    required: {
                                        value: true,
                                        message: "Password is Required",
                                    },
                                })}
                                    errors={errors.password}
                                    autocomplete='new-password'
                                />
                            </ElementWrapper>
                            <ElementWrapper>
                                <Input
                                    id="password_confirmation"
                                    label="Password Confirmation"
                                    type="password"
                                    ref={register({
                                    required: {
                                        value: true,
                                        message: "Password Confirmation is Required",
                                    },
                                })}
                                    errors={errors.password_confirmation}
                                    autocomplete='new-password'
                                />
                            </ElementWrapper>
                            <ElementWrapper>
                                <Button>Register as Student</Button>
                            </ElementWrapper>
                        </Form>

                    </FormWrapper>
                </AuthContainer>
            </Auth>
            <a href="https://www.iubenda.com/terms-and-conditions/78095235"
               className="iubenda-white no-brand iubenda-embed terms-conditions" title="Terms and Conditions ">Terms and
                Conditions</a>
        </MainWrapper>
    );
};

export default Login;
